import { useParams, Navigate } from "react-router-dom";
import { uniquePieceData } from "../types/uniquepiece";
import UniquePieceBlock from "../components/uniquepiece/uniquepieceBlock";

export default function UniquePieceDetail() {
  const { slug } = useParams();
  const item = uniquePieceData.find((i) => i.slug === slug);

  if (!item) return <Navigate to="/journal" />;

  return (
    <section className="max-w-5xl mx-auto px-4 py-6">
      <UniquePieceBlock item={item} />

      {item.photographer && (
        <div className="flex justify-center">
          <a
            href={item.photographer.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 hover:underline"
          >
            {/* logo Instagram outline, même que le reste du site */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
              <circle cx="12" cy="12" r="4" />
              <circle cx="17" cy="7" r="1" fill="currentColor" stroke="none" />
            </svg>

            <span className="font-medium">@{item.photographer.name}</span>
          </a>
        </div>
      )}

      {/* Navigation précédente / suivante */}
      <div className="mt-16 flex justify-between text-sm">
        {/* Trouver l’index courant */}
        {(() => {
          const idx = uniquePieceData.findIndex((i) => i.slug === slug);
          const prev = uniquePieceData[idx - 1];
          const next = uniquePieceData[idx + 1];
          return (
            <>
              {prev ? (
                <a
                  href={`/uniquepiece/${prev.slug}`}
                  className="hover:underline"
                >
                  ← {prev.title}
                </a>
              ) : (
                <span />
              )}
              {next ? (
                <a
                  href={`/uniquepiece/${next.slug}`}
                  className="hover:underline"
                >
                  {next.title} →
                </a>
              ) : (
                <span />
              )}
            </>
          );
        })()}
      </div>
    </section>
  );
}
